import { render, staticRenderFns } from "./advancedVersion.vue?vue&type=template&id=6594ab48&scoped=true"
import script from "./advancedVersion.vue?vue&type=script&lang=js"
export * from "./advancedVersion.vue?vue&type=script&lang=js"
import style0 from "./advancedVersion.vue?vue&type=style&index=0&id=6594ab48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6594ab48",
  null
  
)

export default component.exports